module.exports = __webpack_public_path__ + "img/manda_014.6d89f966.png";